import { useMemo, useState, useEffect, useRef } from 'preact/hooks';

const useInView = (options = {}) => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const ref = useRef(null);

  const observer = useMemo(
    () =>
      new IntersectionObserver(([entry]) => {
        setIsIntersecting(entry.isIntersecting);
      }, options),
    [options],
  );

  useEffect(() => {
    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [observer, ref]);

  return [
    ref,
    isIntersecting,
    () => {
      observer.disconnect();
    },
  ];
};

export default useInView;
